<template>
    <div class="praise">
      <div class="container banner">
        <img src="../../static/img/about/banner.png" style="width: 100%;margin-bottom: 60px;" alt="">
        <div class="content">
          <div class="bread">
            您现在的位置：
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item >口碑见证</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <h3 class="meal-title"><span class="title-line"></span>口碑见证<span class="title-line"></span></h3>

              <el-carousel  arrow="always" ref="team" height="780px" indicator-position="none" :autoplay="false">
                <el-carousel-item v-for="item in teamList" :key="item.id" name="item.id">
                  <div class="kl-in">
                    <img :src="item.src" class="kl-img" alt="">
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="toggle-box">
                <ul class="kl-team">
                  <li class="team-item" v-for="item in teamList" :key="item.id" @click="toggleTeam(item.id)">
                    <img :src="item.src" alt="">
                  </li>
                </ul>
              </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "praise",
      data(){
          return{
            teamList:[
              {
                id:1,
                src:'../../static/img/praise/1.png',
              },
              {
                id:2,
                src:'../../static/img/praise/2.png',
                name:'顶级专业医护团队'
              },
              {
                id:3,
                src:'../../static/img/praise/3.png',
                name:'合美产后康复王牌团队'
              },
              {
                id:4,
                src:'../../static/img/praise/4.png',
                name:'高级营养师+星级大厨'
              },
              {
                id:5,
                src:'../../static/img/praise/5.png',
                name:'强强联合铸造合美实力'
              },
            ],
          }
      },
      methods:{
        toggleTeam:function(id){
          this.index = id;
          this.$refs.team.setActiveItem(id-1)
        },
      }
    }
</script>

<style scoped lang="less">
.praise{
  .bread{
    margin-bottom: 20px;
    font-size: 12px;
    color:#999999;
    .el-breadcrumb{
      vertical-align: middle;
      display: inline-block;
      span{
        font-size: 12px;
        color:#999999;
      }
    }
  }
  .meal-title{
    margin-bottom: 50px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .el-carousel{
    margin-bottom: 20px!important;
    .el-carousel__arrow--left,.el-carousel__arrow--right{
      width: 30px!important;
      height: 64px!important;
      background-color: #fff!important;
    }
  }
  .kl-in{
    background-color: #fff;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .kl-img{
      display: inline-block;

    }
    .kl-content{
      width: 588px;
      vertical-align: top;
      padding-top: 68px;
      display: inline-block;
      .kl-title{
        font-size: 24px;
        color:#333333;
        margin-bottom: 28px;
      }
      .kl-article{
        font-size: 14px;
        line-height: 28px;
        color:#666666;
      }
    }
  }
  .toggle-box{
    width: 100%;
    height: 150px;
    margin-bottom: 80px;
    .kl-team{
      display: flex;
      justify-content: space-between;
      .team-item{
        cursor: pointer;
        transition: all 0.3s ease;
        width: 232px;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #cccccc;
        &:hover{
          -webkit-transform: scale(1.1);
          -moz-transform: scale(1.1);
          -ms-transform: scale(1.1);
          -o-transform: scale(1.1);
          transform: scale(1.1);
        }
        img{
          max-width: 232px;
          max-height: 150px;
          background-color: #43484c;
        }
        .team-title{
          display: block;
          background-color: #a2774d;
          text-align: center;
          color: #ffffff;
          line-height: 30px;
          width: 100%;
          height: 30px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/praise.vue